import React from 'react';
import {
  Toolbar,
  AppBar,
  Typography,
  Slide,
  Divider,
  Box,
  useScrollTrigger,
  useMediaQuery,
} from '@mui/material';

import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { SIDEBAR_WIDTH, COLLAPSED_SIDEBAR_WIDTH } from './Sidebar'
import { useSidebar } from '../../helpers/contextHelpers';
import { useTranslation } from '../../helpers/i18n/useTranslation';
import { RTHelpDropdown, RTUserDropdown } from '@videostream/route-this-login-react';

const HEADER_HEIGHT = 102;

function HideOnScroll(props) {
  const { children, window } = props;
  const trigger = useScrollTrigger({ target: window });

  return (
    <Slide appear={false} direction="down" in={!trigger}>
      {children}
    </Slide>
  );
}

type HeaderProps = {
  pageName: string;
  tenantDisplayName: string;
}

export default function Header({ pageName, tenantDisplayName }: HeaderProps) {
  const { translate } = useTranslation();
  const { expanded } = useSidebar();
  
  const sm = useMediaQuery('(min-width:732px)');

  const formattedPageName = {
    'Installations': translate('installations'),
    'Users': translate('users'),
    'MainSettings': translate('main_settings'),
    'TerminologySettings': translate('terminology'),
    'EquipmentSettings': translate('equipment'),
    'SecuritySettings': translate('security'),
    'CertificateSettings': translate('branding'),
    'tenants': translate('tenants'),
    'SMSSettings': translate('sms_settings'),
    'MobileSettings': translate('mobile_settings'),
  }
  const simpleHeaderPaths = ['tenants'];

  return (
    <>
    {/* Have header take up space in layout*/}
    <Box sx={{ minHeight: `${HEADER_HEIGHT}px`, width: `calc(100% - ${expanded ? SIDEBAR_WIDTH : COLLAPSED_SIDEBAR_WIDTH}px)`, }}></Box>

    <HideOnScroll>
      <AppBar sx={{
        bgcolor: theme => theme.palette.common.white,
        boxShadow: 0,
        width: `calc(100% - ${expanded ? SIDEBAR_WIDTH : COLLAPSED_SIDEBAR_WIDTH}px)`,
        minHeight: `${HEADER_HEIGHT}px`,
        maxHeight: `${HEADER_HEIGHT}px`
      }}>
        <Toolbar sx={{ height: `${HEADER_HEIGHT}px` }}
        >
          <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%', marginLeft: '15px' }}>
            <Box sx={{ display: 'flex', alignItems: 'center', paddingTop: '30px' }}>
              {sm && !simpleHeaderPaths.includes(pageName) && <Typography variant="headlineM" sx={{ color: theme => theme.palette.secondary.main }}>
                {tenantDisplayName ? tenantDisplayName : <div role="progressbar"></div>}
              </Typography>}
              {sm && !simpleHeaderPaths.includes(pageName) && <ChevronRightIcon sx={{ fontSize: '32px', color: theme => theme.palette.common.neutral80, marginLeft: '5px', marginRight: '5px' }}/>}
              <Typography variant="h1" sx={{
                color: theme => theme.palette.secondary.main,
                fontSize: '28px',
                letterSpacing: '-0.01em',
                fontWeight: 400,
                lineHeight: '36px',
                mb: '2px',
              }}>
                {formattedPageName[pageName]}
              </Typography>
            </Box>
            <Box sx={{ paddingTop: '20px', marginRight: '20px', display : 'flex' }}>
              <RTHelpDropdown  />
              <RTUserDropdown apiUrl={process.env.NEXT_PUBLIC_AUTH_API_URL} redirectUrl='/login' sx={{ marginLeft : '5px'}} />
            </Box>
          </Box>
        </Toolbar>

        <Divider variant="inset" sx={{ marginLeft: '40px', marginRight: '44px' }} />

      </AppBar>
    </HideOnScroll>
    </>
  );
}
